import API from './api.svelte.js';
import { notificate } from './notification.js';

let evidencesPromise;
let evidences = [];


export function search(config = {}) {

    evidencesPromise = API.search('evidence', config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pEvidences => {
            evidences = pEvidences;
            return evidences;
        })
    ;
    return evidencesPromise;
}

export function find(id, config = {}) {
    let evidence;
    let evidencePromise = API.find('evidence', id, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pIp => {
            evidence = pIp;
            return evidence;
        })
    ;
    return evidencePromise;
}

export function save(data, files = [], config = {}, resource = null) {

    let file;
    let url = 'evidence';


    if (data.finding_id && !data.id) {
        url = url + "/" + data.finding_id;

        if(files && !files.length) {
            file = [];
            file.push(files)
        }
    }

    return API.save(url, data, file, config)
        .then(async (response) => {
            if (!response.ok) {

                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: 'Evidencia'});
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export function getContent(id, config={}){
    let evidence;
    let url = 'evidence/' + id + '/content'
    let evidencePromise = API.getFile(url, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pEvidence => {
            evidence = pEvidence;
            return evidence;
        })
    ;
    return evidencePromise;
}

export function del(evidence, config = {}) {
    return API.del('evidence', evidence.id, config)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                notificate('delete_error', "toast", {data: "Evidencia"});
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: "Evidencia"});
            return evidences;
        })
    ;
}

export default{
    search,
    find,
    save,
    getContent,
    del,
}